var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTool3X3 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none",
  viewBox: "0 0 15 15",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 0.5,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 5.857,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 11.214,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 0.5,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 5.857,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 11.214,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 0.5,
  y: 5.857,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 5.857,
  y: 5.857,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 11.214,
  y: 5.857,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 0.5,
  y: 5.857,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 5.857,
  y: 5.857,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 11.214,
  y: 5.857,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 0.5,
  y: 11.214,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 5.857,
  y: 11.214,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 3.286,
  x: 11.214,
  y: 11.214,
  stroke: "#6AD2FF",
  rx: 0.5
})));
export { SvgTool3X3 as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-3x3.svg";